import clsx from 'clsx'

interface LabelProps {
  className?: string
  isLoading?: boolean
  label: string
  value: string
}

export default function Label({
  className,
  isLoading = false,
  label,
  value,
}: Readonly<LabelProps>) {
  return (
    <div className={clsx('col-span-1 flex flex-col gap-y-2', className)}>
      <span className="font-semibold text-xs">{label}</span>
      {isLoading ? (
        <div className="h-4 w-16 animate-pulse rounded bg-gray-200" />
      ) : (
        <span className="text-xs">{value}</span>
      )}
    </div>
  )
}
